import { render, staticRenderFns } from "./WalletTip.vue?vue&type=template&id=37df8a13&scoped=true"
import script from "./WalletTip.vue?vue&type=script&lang=js"
export * from "./WalletTip.vue?vue&type=script&lang=js"
import style0 from "./WalletTip.vue?vue&type=style&index=0&id=37df8a13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37df8a13",
  null
  
)

export default component.exports